module.exports = __webpack_public_path__ + "img/148.4f7076b2.jpg";